/**
 * 文字列操作ユーティリティ
 */

/**
 * パスワードをマスク表示する
 * @param {string} password - マスクするパスワード
 * @returns {string} マスクされたパスワード（例: ●●●●●●）
 */
export const maskPassword = (password) => {
    if (!password) return ''
    // パスワードの長さに応じて●を表示（最小6個、最大12個）
    const length = Math.min(Math.max(password.length, 6), 12)
    return '●'.repeat(length)
}
